import dots from '../assets/dots.svg';
import { colors } from './colors';
import Status from '../components/Status';
import ClientLink from '../components/ClientLink/ClientLink';
import File from '../components/File/File';
import dayjs from 'dayjs';
import formatNumber from '../utils/formatNumber';
import formatPhoneNumber from '../utils/formatPhoneNumber';
import { toast } from 'react-toastify';
import alert from '../helpers/alert';
import copyToClipboard from '../utils/copyToClipboard';
import Modal from '../components/Modal/Modal';
import DealAutos from '../pages/Deal/DealAutos';
import checkStockCar from '../utils/checkStockCar';
import AddButton from '../components/AddButton/AddButton';
import fixDateTimezone from '../utils/fixDateTimezone';
import formatDate from '../utils/formatDate';
import { COLORS } from '../components/Selects/SelectColor';
import leadDealStatusColor from '../utils/leadDealStatusColor';

export const CLIENTS = [
  {
    Header: 'Ð¤ÐÐ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
    accessor: (row) => `${row.name} ${row.surname}`,
    width: '15%',
  },
  {
    Header: 'ÐÐÐ',
    accessor: 'iin',
    width: '15%',
  },
  // {
  //   Header: 'ÐÐ¾Ð»Ð¶Ð½Ð¾ÑÑÑ',
  //   accessor: 'employe',
  // },
  {
    Header: 'Ð¢ÐµÐ»ÐµÑÐ¾Ð½',
    accessor: (row) => formatPhoneNumber(row.phone),
    width: '15%',
    disableSortBy: true,
  },
  {
    Header: 'E-mail',
    accessor: 'email',
    width: '15%',
    disableSortBy: true,
  },
  {
    Header: 'ÐÐ¾ÑÐ¾Ð´',
    accessor: (row) => row?.city?.title,
    width: '10%',
  },
  {
    Header: 'Ð¯Ð·ÑÐº',
    accessor: 'language.title',
    width: '10%',
    disableSortBy: true,
  },
  {
    Header: 'Ð¡ÑÐ°ÑÑÑ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸',
    accessor: (row) => (
      <Status
        status={
          (row?.notarial_verification == 1 && 'Ð¾Ð¶Ð¸Ð´Ð°ÐµÑ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸') ||
          (row?.notarial_verification == 2 && 'Ð¿ÑÐ¾ÑÐµÐ» Ð¿ÑÐ¾Ð²ÐµÑÐºÑ') ||
          (row?.notarial_verification == 3 && 'Ð½Ðµ Ð¿ÑÐ¾ÑÐµÐ» Ð¿ÑÐ¾Ð²ÐµÑÐºÑ')
        }
        color={row?.notarial_verification == 1 ? colors.dimGray : '#fff'}
        backgroundColor={
          (row?.notarial_verification == 1 && '#fff') ||
          (row?.notarial_verification == 2 && '#9EC5A9') ||
          (row?.notarial_verification == 3 && '#FFA1A1')
        }
      />
    ),
    width: '15%',
  },
  {
    Header: <img src={dots} alt="Dots" />,
    accessor: 'dots',
  },
];
export const NOTARY_CLIENTS = [
  {
    Header: 'Ð¤ÐÐ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
    accessor: (row) => `${row.name} ${row.surname}`,
    width: '30%',
  },
  {
    Header: 'ÐÐÐ',
    accessor: (row) => (
      <div
        style={{ display: 'inline-flex', alignItems: 'center' }}
        className="hover-lighten"
        onClick={() => {
          copyToClipboard(row.iin);
          alert.success('ÐÐÐ ÑÑÐ¿ÐµÑÐ½Ð¾ ÑÐºÐ¾Ð¿Ð¸ÑÐ¾Ð²Ð°Ð½ Ð² Ð±ÑÑÐµÑ Ð¾Ð±Ð¼ÐµÐ½Ð°');
        }}
      >
        <p style={{ minWidth: 90 }}>{row.iin}</p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
          style={{ marginLeft: 5 }}
        >
          <path
            d="M3.75004 4.04167V1.66667C3.75004 1.4567 3.83345 1.25534 3.98191 1.10687C4.13038 0.958407 4.33174 0.875 4.54171 0.875H9.61946L11.2028 2.45833H15.625C15.835 2.45833 16.0364 2.54174 16.1848 2.69021C16.3333 2.83867 16.4167 3.04004 16.4167 3.25V11.1667C16.4167 11.3766 16.3333 11.578 16.1848 11.7265C16.0364 11.8749 15.835 11.9583 15.625 11.9583H13.25V14.3333C13.25 14.5433 13.1666 14.7447 13.0182 14.8931C12.8697 15.0416 12.6683 15.125 12.4584 15.125H1.37504C1.16508 15.125 0.963714 15.0416 0.815248 14.8931C0.666781 14.7447 0.583374 14.5433 0.583374 14.3333V4.83333C0.583374 4.62337 0.666781 4.42201 0.815248 4.27354C0.963714 4.12507 1.16508 4.04167 1.37504 4.04167H3.75004ZM3.75004 5.625H2.16671V13.5417H11.6667V11.9583H3.75004V5.625ZM5.33337 2.45833V10.375H14.8334V4.04167H10.5473L8.96396 2.45833H5.33337Z"
            fill="var(--brand-primary)"
          />
        </svg>
      </div>
    ),
    width: '46%',
  },
  {
    Header: 'Ð¡ÑÐ°ÑÑÑ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸',
    accessor: (row) => (
      <Status
        status={
          (row?.notarial_verification == 1 && 'Ð¾Ð¶Ð¸Ð´Ð°ÐµÑ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸') ||
          (row?.notarial_verification == 2 && 'Ð¿ÑÐ¾ÑÐµÐ» Ð¿ÑÐ¾Ð²ÐµÑÐºÑ') ||
          (row?.notarial_verification == 3 && 'Ð½Ðµ Ð¿ÑÐ¾ÑÐµÐ» Ð¿ÑÐ¾Ð²ÐµÑÐºÑ')
        }
        color={row?.notarial_verification == 1 ? colors.dimGray : '#fff'}
        backgroundColor={
          (row?.notarial_verification == 1 && '#fff') ||
          (row?.notarial_verification == 2 && '#9EC5A9') ||
          (row?.notarial_verification == 3 && '#FFA1A1')
        }
      />
    ),
    width: '15%',
  },

  {
    Header: <img src={dots} alt="Dots" />,
    accessor: 'dots',
  },
];

// Ð¡ÑÐ¼Ð¼Ð° ÑÐ¸ÑÐ¸Ð½ Ñ Ð·Ð°Ð¿Ð°ÑÐ¾Ð¼ Ð¿Ð¾Ð´ ÐºÐ¾Ð»Ð¾Ð½ÐºÑ Ñ "ÑÑÐµÐ¼Ñ ÑÐ¾ÑÐºÐ°Ð¼Ð¸": ÑÐ°Ð½ÑÑÐµ Ð²ÑÑÐ¾Ð´Ð¸Ð»Ð¾ 106%,
// Ð¸ Ð±ÑÐ°ÑÐ·ÐµÑ Ð¾ÑÐ±Ð¸ÑÐ°Ð» Ð¼ÐµÑÑÐ¾ Ñ Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÐµÐ¹ ÐºÐ¾Ð»Ð¾Ð½ÐºÐ¸ â ÑÑÐ°ÑÑÑ ÑÑÐ»Ð¾Ð¿ÑÐ²Ð°Ð»ÑÑ Ð´Ð¾ 40px.
export const LEADS = [
  {
    Header: 'ÐÐ°ÑÐ°',
    accessor: (row) => formatDate(fixDateTimezone(row.createdAt), true),
    width: '8%',
  },
  {
    Header: 'ÐÐ»Ð¸ÐµÐ½Ñ',
    accessor: (row) => row.client?.fullName,
    width: '11%',
  },
  {
    Header: 'ÐÐµÐ½ÐµÐ´Ð¶ÐµÑ',
    accessor: 'manager.fullName',
    width: '10%',
  },
  {
    Header: 'ÐÐ¼Ñ',
    accessor: 'fio',
    width: '8%',
  },
  {
    Header: 'ÐÐ°ÑÐºÐ° Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ',
    accessor: 'markAndModel.title',
    width: '9%',
    disableSortBy: true,
  },

  {
    Header: 'ÐÑÑÐ¾ÑÐ½Ð¸Ðº',
    accessor: 'source.title',
    width: '8%',
    disableSortBy: true,
  },
  {
    Header: 'Ð¢ÐµÐ»ÐµÑÐ¾Ð½',
    accessor: (row) => formatPhoneNumber(row.phone),
    width: '10%',
    disableSortBy: true,
  },
  {
    Header: 'E-mail',
    accessor: 'email',
    width: '10%',
    disableSortBy: true,
  },
  {
    Header: 'Ð¯Ð·ÑÐº',
    accessor: 'client.language',
    width: '5%',
    disableSortBy: true,
  },
  {
    Header: 'Ð¡ÑÐ°ÑÑÑ',
    accessor: (row) => <Status status={row.status?.title} color={colors.dimGray} />,
    width: '9%',
    disableSortBy: true,
  },
  // Ð¡ÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸ Ð»Ð¸Ð´Ð°: Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð½ÑÐ¶Ð½Ð¾ Ð²Ð¸Ð´ÐµÑÑ Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð¸Ðµ Ð±Ð°Ð½ÐºÐ° Ð¿ÑÑÐ¼Ð¾ Ð² ÑÐ¿Ð¸ÑÐºÐµ, Ð½Ðµ
  // Ð¾ÑÐºÑÑÐ²Ð°Ñ ÐºÐ°ÑÑÐ¾ÑÐºÑ. ÐÐµÐ»ÑÐ½ÑÐ¹ â bankApproved (ÑÐ°ÐºÑ Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð¸Ñ Ð¸Ð· Ð·Ð°ÑÐ²Ð¾Ðº, Ð° Ð½Ðµ ÑÑÐ°ÑÑÑ
  // 27: ÑÐ´ÐµÐ»ÐºÐ° ÑÑÐ¾Ð´Ð¸Ñ Ð´Ð°Ð»ÑÑÐµ Ð¿Ð¾ ÑÑÐ°Ð¿Ð°Ð¼, Ð° Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð¸Ðµ Ð¾ÑÑÐ°ÑÑÑÑ), ÐºÑÐ°ÑÐ½ÑÐ¹ â Ð¿ÑÐ¾Ð²Ð°Ð».
  {
    Header: 'Ð¡Ð´ÐµÐ»ÐºÐ°',
    accessor: (row) =>
      row.dealStatus?.title ? (
        <Status status={row.dealStatus.title} color={leadDealStatusColor(row.dealStatus)} />
      ) : null,
    width: '11%',
    disableSortBy: true,
  },
  {
    Header: <img src={dots} alt="Dots" />,
    accessor: 'dots',
  },
];

export const DEALS = ({ onCarClick }) => [
  {
    Header: 'ÐÐ°ÑÐ°',
    accessor: (row) => formatDate(fixDateTimezone(row.createdAt), true),
    width: '7%',
  },
  {
    Header: 'ÐÐ»Ð¸ÐµÐ½Ñ',
    accessor: (row) => row?.client?.fullName,
    width: '10%',
  },
  {
    Header: 'Ð¡ÑÐ¼Ð¼Ð° ÐºÐ¾Ð½ÑÑÐ°ÐºÑÐ°, KZT',
    accessor: (row) => formatNumber(row.sum),
    width: '10%',
  },
  {
    Header: 'Ð¡ÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸',
    accessor: (row) => (row.status?.title ? <Status status={row.status?.title} color={colors.dimGray} /> : null),
    width: '15%',
    disableSortBy: true,
  },
  {
    Header: 'Ð¡ÑÐ°ÑÑÑ Ð¾Ð¿Ð»Ð°ÑÑ',
    accessor: (row) =>
      row.statusPayment?.title ? <Status status={row.statusPayment?.title} color={colors.dimGray} /> : null,
    width: '10%',
    disableSortBy: true,
  },
  {
    Header: 'ÐÐ¾ÑÐ¾Ð´',
    accessor: (row) => {
      return (row?.cars?.[0]?.city?.title);
    },
    width: '10%',
    disableSortBy: true,
  },
  {
    Header: 'ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ð¸',
    accessor: (row) => {
      return (
        <a
          onClick={() => {
            onCarClick && onCarClick(row?.id);
          }}
        >
          {row?.cars
            ?.map(
              (item) =>
                item?.container?.mark?.name + ' ' + item?.container?.model?.name + ' ' + item?.complectation?.title
            )
            .join(', ')}
        </a>
      );
    },
    width: '10%',
    disableSortBy: true,
  },
  {
    Header: 'ÐÐºÑÐµÑÑÑÐ°ÑÑ',
    accessor: (row) => row.additions,
    width: '12%',
    disableSortBy: true,
  },
  // {
  //   Header: 'ÐÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½ÑÐ¹ Ð²Ð·Ð½Ð¾Ñ',
  //   accessor: (row) => formatNumber(row?.creditAppeal?.initialFee),
  //   width: '10%',
  //   disableSortBy: true,
  // },
  // {
  //   Header: 'Ð¡ÑÐ¾Ðº ÐºÑÐµÐ´Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ (Ð¼ÐµÑ)',
  //   accessor: 'creditAppeal.period',
  //   width: '10%',
  //   disableSortBy: true,
  // },
  // {
  //   Header: 'ÐÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÐµÐ¶',
  //   accessor: (row) => formatNumber(row?.creditAppeal?.paymentForMonth),
  //   width: '10%',
  //   disableSortBy: true,
  // },
  {
    Header: 'ÐÑÐ²ÐµÑÑÑÐ²ÐµÐ½Ð½ÑÐ¹ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ',
    accessor: (row) => (row.manager ? row.manager?.name + ' ' + row.manager?.surname : null),
  },
  {
    Header: (
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <img src={dots} alt="Dots" />
      </div>
    ),
    accessor: 'dots',
  },
];
export const NOTARY_DEALS = [
  {
    Header: 'ÐÐ°ÑÐ°',
    accessor: (row) => formatDate(fixDateTimezone(row.createdAt), true),
    width: '15%',
  },
  {
    Header: 'ÐÐ»Ð¸ÐµÐ½Ñ',
    accessor: (row) => row?.client?.fullName,
    width: '20%',
  },
  {
    Header: 'Ð¡ÑÐ¼Ð¼Ð° ÐºÐ¾Ð½ÑÑÐ°ÐºÑÐ°, KZT',
    accessor: (row) => formatNumber(row.sum),
    width: '15%',
  },
  {
    Header: 'ÐÐ¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ',
    accessor: (row) => (
      <Status
        status={row?.power_of_attorney ? 'Ð¿Ð¾Ð»ÑÑÐµÐ½Ð¾' : 'Ð¾Ð¶Ð¸Ð´Ð°ÐµÑ Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸'}
        color={colors.white}
        backgroundColor={row?.power_of_attorney ? '#9EC5A9' : '#FFA1A1'}
      />
    ),
    width: '20%',
  },
  {
    Header: 'Ð¡ÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸',
    accessor: (row) => (row.status?.title ? <Status status={row.status?.title} color={colors.dimGray} /> : null),
    width: '30%',
    disableSortBy: true,
  },
  {
    Header: (
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <img src={dots} alt="Dots" />
      </div>
    ),
    accessor: 'dots',
  },
];
export const NOTARY_DEALS_CREDIT = [
  {
    Header: 'ÐÐ°ÑÐ°',
    accessor: (row) => formatDate(fixDateTimezone(row.createdAt), true),
    width: '15%',
  },
  {
    Header: 'ÐÐ»Ð¸ÐµÐ½Ñ',
    accessor: (row) => row?.client?.fullName,
    width: '10%',
  },
  {
    Header: 'Ð¡ÑÐ¼Ð¼Ð° ÐºÐ¾Ð½ÑÑÐ°ÐºÑÐ°, KZT',
    accessor: (row) => formatNumber(row.sum),
    width: '10%',
  },
  {
    Header: 'Ð¡Ð¾Ð³Ð»Ð°ÑÐ¸Ðµ ÑÑÐ¿ÑÑÐ³Ð°',
    accessor: (row) => (
      <Status
        status={row?.spouse_consent ? 'Ð¿Ð¾Ð»ÑÑÐµÐ½Ð¾' : 'Ð¾Ð¶Ð¸Ð´Ð°ÐµÑ Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸'}
        color={colors.white}
        backgroundColor={row?.spouse_consent ? '#9EC5A9' : '#FFA1A1'}
      />
    ),
    width: '20%',
  },
  {
    Header: 'ÐÐ¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ',
    accessor: (row) => (
      <Status
        status={row?.power_of_attorney ? 'Ð¿Ð¾Ð»ÑÑÐµÐ½Ð¾' : 'Ð¾Ð¶Ð¸Ð´Ð°ÐµÑ Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸'}
        color={colors.white}
        backgroundColor={row?.power_of_attorney ? '#9EC5A9' : '#FFA1A1'}
      />
    ),
    width: '20%',
  },
  {
    Header: 'Ð¡ÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸',
    accessor: (row) => (row.status?.title ? <Status status={row.status?.title} color={colors.dimGray} /> : null),
    width: '30%',
    disableSortBy: true,
  },
  {
    Header: (
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <img src={dots} alt="Dots" />
      </div>
    ),
    accessor: 'dots',
  },
];

export const EQUIPMENTS = [
  {
    Header: 'ÐÐ°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ðµ',
    accessor: 'title',
    width: '50%',
  },
  {
    Header: 'ÐÐ´. Ð¸Ð·Ð¼.',
    accessor: () => 'ÑÑÑÐºÐ°',
    width: '17%',
    disableSortBy: true,
  },
  {
    Header: 'ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾',
    accessor: 'count',
    width: '17%',
  },
  {
    Header: 'Ð¦ÐµÐ½Ð°, KZT',
    accessor: (row) => formatNumber(row.price),
    width: '17%',
  },
  {
    Header: <img src={dots} alt="Dots" />,
    accessor: 'dots',
  },
];

export const ADDITIONAL_SERVICES = [
  {
    Header: 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ',
    accessor: 'title',
    width: '40%',
  },
  {
    Header: 'ÐÐ´. Ð¸Ð·Ð¼.',
    accessor: () => 'ÑÑÐ»ÑÐ³Ð°',
    width: '18%',
    disableSortBy: true,
  },
  {
    Header: 'Ð¦ÐµÐ½Ð°, KZT',
    accessor: (row) => formatNumber(row.price),
    width: '18%',
  },
  {
    Header: 'ÐÐ¾ÑÐ¾Ð´',
    accessor: (row) => row?.city?.title,
    width: '18%',
  },
  {
    Header: <img src={dots} alt="Dots" />,
    accessor: 'dots',
  },
];

export const CARS = [
  {
    Header: 'ÐÐ°ÑÐºÐ°',
    accessor: 'mark',
    width: '8%',
  },
  {
    Header: 'ÐÐ¾Ð´ÐµÐ»Ñ',
    accessor: 'model',
    width: '8%',
  },
  {
    Header: 'ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ',
    accessor: 'complectation.title',
    width: '8%',
  },
  {
    Header: 'ÐÐ¾Ð´ Ð²ÑÐ¿ÑÑÐºÐ°',
    accessor: 'issueYear',
    width: '5%',
  },
  {
    Header: 'VIN',
    accessor: 'vin',
    width: '11%',
  },
  {
    // ÐÐ¾Ð»Ð¾Ð½ÐºÐ° Ð²ÑÐµÐ³Ð´Ð° Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°Ð»Ð° Ð³Ð¾ÑÐ¾Ð´; Ñ Ð¿Ð¾ÑÐ²Ð»ÐµÐ½Ð¸ÐµÐ¼ Ð¾ÑÐ´ÐµÐ»ÑÐ½Ð¾Ð³Ð¾ ÑÐ¸Ð»ÑÑÑÐ° Ð¿Ð¾ ÐÐ¦
    // Ð¿ÑÐµÐ¶Ð½ÑÑ Ð¿Ð¾Ð´Ð¿Ð¸ÑÑ ÑÐ±Ð¸Ð²Ð°Ð»Ð° Ð±Ñ Ñ ÑÐ¾Ð»ÐºÑ.
    Header: 'ÐÐ¾ÑÐ¾Ð´',
    accessor: 'city.title',
    width: '11%',
    disableSortBy: true,
  },
  {
    Header: 'Ð¦Ð²ÐµÑ',
    accessor: (row) => (
      <div style={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}>
        <div
          style={{
            backgroundColor: row.color,
            width: '12px',
            height: '12px',
            borderRadius: '100%',
          }}
        />
        <p>{COLORS.find((item) => row?.color === item?.value)?.label || row?.color}</p>
      </div>
    ),
    width: '11%',
    disableSortBy: true,
  },
  {
    Header: 'Ð Ð Ð¦, KZT',
    accessor: (row) => formatNumber(row.price),
    width: '11%',
  },
  {
    Header: 'Ð¢Ð¸Ð¿ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ',
    accessor: 'complectation.engine.title',
    width: '7%',
    disableSortBy: true,
  },
  {
    Header: 'Ð¡ÑÐ°ÑÑÑ',
    accessor: (row) => (
      <Status status={checkStockCar(row?.checkStock) ? 'Ð Ð½Ð°Ð»Ð¸ÑÐ¸Ð¸' : 'ÐÐµÑ Ð² Ð½Ð°Ð»Ð¸ÑÐ¸Ð¸'} color={colors.dimGray} />
    ),
    width: '11%',
    disableSortBy: true,
  },
  {
    Header: <img src={dots} alt="Dots" />,
    accessor: 'dots',
    width: '11%',
  },
];
export const CARS_SELL_EQUIPMENT = [
  {
    Header: 'ÐÐ°ÑÐºÐ°',
    accessor: 'mark',
    width: '16%',
  },
  {
    Header: 'ÐÐ¾Ð´ÐµÐ»Ñ',
    accessor: 'model',
    width: '16%',
  },
  {
    Header: 'ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ',
    accessor: 'complectation.title',
    width: '14%',
  },
  {
    Header: 'ÐÐ¾Ð´ Ð²ÑÐ¿ÑÑÐºÐ°',
    accessor: 'issueYear',
    width: '14%',
  },
  {
    Header: 'ÐÐ¸Ð»ÐµÑÑÐºÐ¸Ð¹ ÑÐµÐ½ÑÑ',
    accessor: 'city.title',
    width: '14%',
    disableSortBy: true,
  },
  {
    Header: 'ÐÐ¾Ð¿ Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ',
    accessor: 'custom__equipments',
    width: '25%',
  },
  {
    Header: <img src={dots} alt="Dots" />,
    accessor: 'dots',
    width: '11%',
  },
];

export const CAR_DEAL = [
  {
    Header: 'ÐÐ°ÑÐ°',
    accessor: (row) => formatDate(fixDateTimezone(row.createdAt), true),
    width: '13%',
  },
  {
    Header: 'Ð¡ÑÐ¼Ð¼Ð° ÐºÐ¾Ð½ÑÑÐ°ÐºÑÐ°, KZT',
    accessor: (row) => formatNumber(row.sum),

  },
  {
    Header: 'ÐÐ»Ð¸ÐµÐ½Ñ',
    accessor: (row) => row?.client?.fullName,

  },
  {
    Header: 'Ð¡ÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸',
    accessor: (row) => (row.status?.title ? <Status status={row.status?.title} color={colors.dimGray} /> : null),

    disableSortBy: true,
  },
  {
    Header: 'Ð¡ÑÐ°ÑÑÑ Ð¾Ð¿Ð»Ð°ÑÑ',
    accessor: (row) =>
      row.statusPayment?.title ? <Status status={row.statusPayment?.title} color={colors.dimGray} /> : null,

    disableSortBy: true,
  },
  {
    Header: <img src={dots} alt="Dots" />,
    accessor: 'dots',
  },
];
export const CAR_EQUIPMENTS = [
  {
    Header: 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ',
    accessor: 'name',
    width: '33%',
  },
  {
    Header: 'Ð¡ÑÐ¼Ð¼Ð°',
    accessor: (row) => formatNumber(row.price),
    width: '33%',
  },
  {
    Header: 'ÐÐ¾Ð»-Ð²Ð¾',
    accessor: 'count',
    width: '33%',
    disableSortBy: true,
  },
  {
    Header: <img src={dots} alt="Dots" />,
    accessor: 'dots',
  },
];

export const MARKS = [
  {
    Header: 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ',
    accessor: 'name',
    width: '100%',
  },
  {
    Header: <img src={dots} alt="Dots" />,
    accessor: 'dots',
  },
];

export const CONTAINERS = [
  {
    Header: 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ',
    accessor: (row) => `${row?.mark?.name} ${row?.model?.name}`,
    width: '100%',
  },
  {
    Header: <img src={dots} alt="Dots" />,
    accessor: 'dots',
  },
];

export const COMPLECTATIONS = [
  {
    Header: 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ',
    accessor: 'name',
    width: '50%',
  },
  {
    Header: 'ÐÐ¿ÑÐ¸Ð¸',
    accessor: 'options',
    width: '50%',
  },
  {
    Header: <img src={dots} alt="Dots" />,
    accessor: 'dots',
    style: { width: 200 },
  },
];

export const LEAD_CLIENTS = [
  {
    Header: 'Ð¤ÐÐ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
    accessor: 'name',
    width: '12.5%',
  },
  {
    Header: 'ÐÐÐ',
    accessor: 'iin',
    width: '12.5%',
  },
  {
    Header: 'VIP',
    accessor: 'vip',
    width: '12.5%',
    disableSortBy: true,
  },
  {
    Header: 'ÐÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ñ',
    accessor: 'company',
    width: '12.5%',
    disableSortBy: true,
  },
  // {
  //   Header: 'ÐÐ¾Ð»Ð¶Ð½Ð¾ÑÑÑ',
  //   accessor: 'employe',
  // },
  {
    Header: 'Ð¢ÐµÐ»ÐµÑÐ¾Ð½',
    accessor: (row) => formatPhoneNumber(row.phone),
    width: '12.5%',
    disableSortBy: true,
  },
  {
    Header: 'E-mail',
    accessor: 'email',
    width: '12.5%',
    disableSortBy: true,
  },
  {
    Header: 'ÐÐ¾ÑÑÐµÐ´Ð½Ð¸Ðº',
    accessor: 'broker',
    width: '12.5%',
    disableSortBy: true,
  },
  {
    Header: 'Ð¯Ð·ÑÐº',
    accessor: 'language',
    width: '12.5%',
    disableSortBy: true,
  },
  {
    Header: <img src={dots} alt="Dots" />,
    accessor: 'dots',
  },
];

export const CLIENT_RECORDS = [
  {
    Header: ' ',
    accessor: 'date',
    width: '16.6%',
  },
  {
    Header: ' ',
    accessor: 'services',
    width: '16.6%',
  },
  {
    Header: ' ',
    accessor: (row) => formatPhoneNumber(row.phone),
    width: '16.6%',
  },
  {
    Header: ' ',
    accessor: 'address',
    width: '16.6%',
  },
  {
    Header: ' ',
    accessor: 'time',
    width: '16.6%',
  },
  {
    Header: ' ',
    accessor: 'status',
    width: '16.6%',
  },
  {
    Header: <img src={dots} alt="Dots" />,
    accessor: 'dots',
  },
];

export const REPORTS = [
  {
    Header: 'ÐÐ°ÑÐ° ÑÐ¾ÑÐ¼Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ Ð¾ÑÑÐµÑÐ°',
    accessor: (row) => formatDate(fixDateTimezone(row.date), true),
    width: '25%',
  },
  {
    Header: 'ÐÐ°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ðµ Ð¾ÑÑÐµÑÐ°',
    accessor: 'name',
    width: '25%',
  },
  {
    Header: 'ÐÐµÑÐ¸Ð¾Ð´',
    accessor: 'period',
    width: '25%',
  },
  {
    Header: 'Ð¡Ð¼Ð¾ÑÑÐµÑÑ Ð¾ÑÑÐµÑ',
    accessor: (row) => <File />,
    width: '25%',
  },
  {
    Header: <img src={dots} alt="Dots" />,
    accessor: 'dots',
  },
];

export const RECORDS = [
  {
    Header: 'ÐÐ°ÑÐ°',
    accessor: (row) => formatDate(fixDateTimezone(row.date)),
    width: '14%',
  },
  {
    Header: 'Ð¤ÐÐ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
    accessor: 'fio',
    width: '14%',
  },
  {
    Header: 'Ð£ÑÐ»ÑÐ³Ð¸',
    accessor: 'type.title',
    width: '14%',
    disableSortBy: true,
  },
  {
    Header: 'Ð¢ÐµÐ»ÐµÑÐ¾Ð½',
    accessor: (row) => formatPhoneNumber(row.phone),
    width: '14%',
    disableSortBy: true,
  },
  {
    Header: 'ÐÐ´ÑÐµÑ ÑÐµÑÐ²Ð¸ÑÐ°',
    accessor: (row) => row?.dealerAddress || 'â',
    width: '14%',
    disableSortBy: true,
  },
  {
    Header: 'ÐÐ°ÑÐ° Ð¸ Ð²ÑÐµÐ¼Ñ',
    accessor: (row) => formatDate(fixDateTimezone(row.date), true),
    width: '14%',
  },
  {
    Header: 'Ð¡ÑÐ°ÑÑÑ',
    accessor: (row) => <Status status={row?.status?.title} color={colors.dimGray} />,
    width: '14%',
    disableSortBy: true,
  },
  {
    Header: <img src={dots} alt="Dots" />,
    accessor: 'dots',
  },
];

export const DEAL_HISTORY = [
  {
    Header: 'ÐÐ°ÑÐ°',
    accessor: (row) => formatDate(row.createdAt, true),
    width: '18%',
  },
  {
    Header: 'ÐÐµÐ¹ÑÑÐ²Ð¸Ðµ',
    accessor: (row) =>
      ({ removed: 'Ð£Ð´Ð°Ð»ÐµÐ½Ð¾ Ð¸Ð· ÑÐ´ÐµÐ»ÐºÐ¸', price_changed: 'ÐÐ·Ð¼ÐµÐ½ÐµÐ½Ð° ÑÐµÐ½Ð°' }[row.action] || row.action),
    width: '18%',
  },
  {
    Header: 'Ð¢Ð¸Ð¿',
    accessor: (row) =>
      ({ equipment: 'ÐÐ¾Ð¿.Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ', service: 'ÐÐ¾Ð¿.ÑÑÐ»ÑÐ³Ð°', car: 'ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ', car_price: 'Ð¦ÐµÐ½Ð° Ð°Ð²ÑÐ¾' }[
        row.itemType
      ] || row.itemType),
    width: '16%',
  },
  {
    Header: 'ÐÐ°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ðµ',
    accessor: 'itemName',
    width: '28%',
  },
  {
    Header: 'Ð¦ÐµÐ½Ð°, KZT',
    accessor: (row) =>
      row.action === 'price_changed' ? `${formatNumber(row.oldPrice)} â ${formatNumber(row.price)}` : formatNumber(row.price),
    width: '10%',
  },
  {
    Header: 'ÐÐµÐ½ÐµÐ´Ð¶ÐµÑ',
    accessor: (row) => (row.manager ? `${row.manager.name || ''} ${row.manager.surname || ''}`.trim() : 'â'),
    width: '10%',
  },
];

export const DOCUMENTS = [
  {
    Header: 'ID',
    accessor: 'id',
    width: '4%',
  },
  {
    Header: 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ',
    accessor: 'type.title',
    width: '48%',
  },
  {
    Header: 'Ð¡ÑÑÐ»ÐºÐ°',
    accessor: (row) => (
      <a target="_blank" href={row.url}>
        {row.url}
      </a>
    ),
    width: '48%',
  },
  {
    Header: <img src={dots} alt="Dots" />,
    accessor: 'dots',
  },
];
